<div class="cd-overlay" *ngIf="visible" role="presentation" (click)="cancel()">
  <section class="cd-box" role="dialog" aria-modal="true" [attr.aria-label]="heading" (click)="$event.stopPropagation()">
    <div class="cd-icon" aria-hidden="true"><i [class]="iconClass"></i></div>
    <h2 class="cd-heading">{{ heading }}</h2>
    <p class="cd-message">{{ message }}</p>

    <div *ngIf="variant === 'primary'; else secondaryActions" #track class="cd-track"
      [class.cd-primary]="variant === 'primary'" [class.cd-done]="completed">
      <div class="cd-fill" [style.width.%]="progress * 100" [class.cd-animate]="!dragging" aria-hidden="true"></div>
      <span class="cd-text" aria-hidden="true">{{ completed ? doneText : slideText }}</span>
      <button
        type="button"
        class="cd-handle"
        [class.cd-animate]="!dragging"
        [style.left.px]="handleLeft"
        [disabled]="completed"
        role="slider"
        aria-label="Slide to confirm"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="progress * 100 | number: '1.0-0'"
        (pointerdown)="startDrag($event)"
        (pointermove)="moveDrag($event)"
        (pointerup)="endDrag($event)"
        (pointercancel)="endDrag($event)"
        (keydown)="onSliderKeydown($event)">
        <i [class]="slideIconClass" aria-hidden="true"></i>
      </button>
    </div>

    <button *ngIf="variant === 'primary'" type="button" class="cd-cancel" (click)="cancel()">
      <i [class]="cancelIconClass" aria-hidden="true"></i>{{ cancelText }}
    </button>

    <ng-template #secondaryActions>
      <div class="cd-actions" [class.cd-primary]="variant === 'primary'">
        <button type="button" class="cd-action cd-no" (click)="cancel()">
          <i [class]="cancelIconClass" aria-hidden="true"></i>{{ cancelText }}
        </button>
        <button type="button" class="cd-action cd-yes" (click)="confirm()">
          <i [class]="confirmIconClass" aria-hidden="true"></i>{{ confirmText }}
        </button>
      </div>
    </ng-template>
  </section>
</div>